import * as trialRegistration from 'actions/trialRegistration';

const { UNAVAILABLE_STATUS } = trialRegistration;

export default function trialRegistrationReducer(state = {}, action) {
  const { type, payload } = action;
  switch (type) {
    case trialRegistration.POST_TRIAL_REGISTRATION_SUCCESS:
      return {
        ...state,
        redirectUrl: payload.redirectURL,
      };
    case trialRegistration.GET_COMPANY_NAME_AVAILABILITY_SUCCESS:
      return {
        ...state,
        companyNameStatus: payload.companyNameStatus,
      };
    case trialRegistration.GET_COMPANY_NAME_AVAILABILITY_FAIL:
      // Assume company is not available if error thrown
      return {
        ...state,
        companyNameStatus: UNAVAILABLE_STATUS,
      };
    case trialRegistration.GET_HOSTNAME_PREFIX_AVAILABILITY_SUCCESS:
      return {
        ...state,
        hostnamePrefixStatus: payload.hostnamePrefixStatus,
      };
    case trialRegistration.GET_HOSTNAME_PREFIX_AVAILABILITY_FAIL:
      // Assume hostname is not available if error thrown
      return {
        ...state,
        hostnamePrefixStatus: UNAVAILABLE_STATUS,
      };
    default:
      return state;
  }
}
